import TcTelefonSmsControlPopup from "../../../components/OB/popups/tc-telefon-fogrulama-popup";
import SessionStorageService from "../../../services/StorageService";
import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Button,
  TextField,
  MenuItem,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Collapse,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router";
import { isyeriRuhsatValidationSchema } from "../../../validations/EmlakBasvuru";
import CaddeSokakAPI from "../../../apis/OB/Get/CaddeSokakAPI";
import FaaliyetListeAPI from "../../../apis/OB/Get/FaaliyetListeAPI";
import BasvuruTuruAPI from "../../../apis/OB/Get/BasvuruTuruAPI";
import MulkiyetDurumuListe from "../../../apis/OB/Get/MulkiyetDurumuListe";
import IsyeriSinifiListe from "../../../apis/OB/Get/IsyeriSinifiListe";
import IsyeriKonumuListe from "../../../apis/OB/Get/IsyeriKonumuListe";
import NumaratajKapiListeAPI from "../../../apis/OB/Get/NumaratajKapiListeAPI";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import IsyeriBasvuruSave from "../../../apis/OB/SaveApi/IsyeriBasvuruSave";
import BilgilendirmePopup from "../../../components/OB/popups/BilgilendirmePopUp";
import { safelyParseNumber } from "../../../helpers/MoneyFormat";
import DocumentTable from "../../../components/OB/BelgeYukleme";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";
import CustomTextField from "../../../components/OB/required-text-field";
import { toast } from "react-toastify";
import DysAPI from "../../../apis/DysAPI";
import Recaptcha from "../../../components/Recaptcha";
import { TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const IsYeriRuhsatBasvuru = () => {
  const recaptchaRef = useRef<any>(null);
  const [recaptchaPassed, setRecaptchaPassed] = useState(false);
  const [recaptchaError, setRecaptchaError] = useState(false);

  let user = SessionStorageService.getUserInfo();
  const [smsControlled, setSmsControlled] = useState(user != null);
  const [tcKimlikNo, setTcKimlikNo] = useState(user ? user.tcKimlikNo : "");
  const [cepTelefonu, setCepTelefonu] = useState("");

  const [basvuruTuruData, setBasvuruTuruData] = useState([]);
  const { mahalleListe } = useContext(ConstantAPISContext);
  const [caddeSokakData, setCaddeSokakData] = useState([]);
  const [numaratajKapiListeDatas, setNumaratajKapiListeDatas] = useState([]);
  const [isyeriSinifiListe, setIsyeriSinifiListe] = useState([]);
  const [isyeriKonumuListe, setIsyeriKonumuListe] = useState([]);
  const [faaliyetListe, setFaaliyetListe] = useState([]);
  const [mulkiyetDurumuListe, setMulkiyetDurumuListe] = useState([]);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [popupAciklama, setPopupAciklama] = useState("");
  const [kayitBasarili, setKayitBasarili] = useState(false);
  const navigate = useNavigate();
  const closePopupSonuc = () => {
    setIsPopupVisible(false);
    setPopupAciklama("");
  };

  const [userControlPopup, setUserControlPopup] = useState(false);
  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  };
  const [isLoad, setIsLoad] = useState(true);
  useEffect(() => {
    if (user == null) {
      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }
  }, []);
  const [documents, setDocuments] = useState<any[]>([]);
  const [docsLoaded, setDocsLoaded] = useState<boolean>(false);
  const documentTableRef = useRef<HTMLDivElement | null>(null);

  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  const handleUpdateDocuments = (updatedDocuments: any) => {
    setDocuments(updatedDocuments);
  };

  useEffect(() => {
    setDocsLoaded(false);

    DysAPI.obBasvuruTanimBelgeList({ rfObBasvuruTanim: 10 })
      .then((res: any) => {
        console.log("Belge listesi response:", res.data);

        const list = (res?.data ?? []).map((b: any, idx: number) => {
          const zorunlu = (b.zorunluEh)
            .toString();

          return {
            id: b.sqId,
            documentName: b.belgeAdi,
            isRequired: ["E"].includes(zorunlu),
            fileName: "",
            file: null,
          };
        });


        setDocuments(list);
      })
      .catch((err: any) => {
        console.error("Belge listesi hatası:", err);
        setDocuments((prevDocs: any[]) =>
          prevDocs.map((doc) => ({
            ...doc,
            file: null,
            fileName: "",
          }))
        );
      })
      .finally(() => {
        setDocsLoaded(true);
      });
  }, []);


  useEffect(() => {
    if (user) {
      IsyeriKonumuListe.getIsyeriKonumuListe(undefined)
        .then((res) => setIsyeriKonumuListe(res.data))
        .catch((err) => console.log(err));

      IsyeriSinifiListe.getIsyeriSinifiListe(undefined)
        .then((res) => setIsyeriSinifiListe(res.data))
        .catch((err) => console.log(err));

      FaaliyetListeAPI.getFaaliyetListe(undefined)
        .then((res) => setFaaliyetListe(res.data))
        .catch((err) => console.log(err));

      MulkiyetDurumuListe.getMulkiyetDurumuListe(undefined)
        .then((res) => setMulkiyetDurumuListe(res.data))
        .catch((err) => console.log(err));
      BasvuruTuruAPI.getBasvuruTuruListe(undefined)
        .then((res) => setBasvuruTuruData(res.data))
        .catch((err) => console.log(err));
    }
  }, []);

  return isLoad ? (
    <>
      <div className="d-flex align-self-strech justify-content-center align-items-center">
        {" "}
        <CircularProgress />
      </div>
      {userControlPopup ? (
        <AciklamaAndUserControlPopup
          open={userControlPopup}
          handleClose={closeUserControlPopup}
          isUserControlPopUp={true}
          description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
        />
      ) : null}
    </>
  ) : (
    <Formik
      initialValues={{
        basvuruTuruId: 10,
        sicilKodu: user?.sicilKodu,
        IacRuhsatBasvuruTuruId: null,
        mahalleKodu: null,
        caddeSokakKodu: null,
        kapiNo: "",
        altKapiNo: "",
        daireNo: "",
        altDaireNo: "",
        siteApartmanAdi: "",
        pafta: "",
        ada: "",
        parsel: "",
        vergiDairesiAdi: "",
        vergiDairesiNo: "",
        ticaretSicilNo: "",
        ustalikBelgeNo: "",
        isyeriSinifiKodu: null,
        binaKullanimTuruKodu: null,
        isyeriKonumuKodu: null,
        mulkiyetDurumuKodu: null,
        acikAlanM2: "",
        kapaliAlanM2: "",
        yazAcilisSaat: null,
        yazKapanisSaat: null,
        kisAcilisSaat: null,
        kisKapanisSaat: null,
        egitimUzaklik: "",
        dershaneUzaklik: "",
        ogrenciYurduUzaklik: "",
        ibadethaneUzaklik: "",
        aciklama: "",
      }}
      validateOnMount={true}
      validationSchema={isyeriRuhsatValidationSchema}
      onSubmit={async (values: any, { resetForm }) => {
        const missingDocuments = documents
          .filter(doc => doc.isRequired) // zorunlu belgeler
          .filter(doc => !doc.fileName);     // henüz yüklenmemiş olanlar

        if (missingDocuments.length > 0) {
          const missingDocNames = missingDocuments.map(d => d.documentName).join(", ");
          toast.error(`Lütfen şu zorunlu belgeleri yükleyin: ${missingDocNames}`);
          documentTableRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
          return; // başvuru burada durur
        }

        // reCAPTCHA’yı tetikle
        const token = await recaptchaRef.current?.handleSubmit();
        if (!token) {
          toast.error("reCAPTCHA doğrulanamadı, lütfen tekrar deneyiniz.");
          return;
        }

        setLoadingSubmit(true);
        console.log("Form Values", values);
        const transformedValues = {
          ...values,
          IacRuhsatBasvuruTuruId: safelyParseNumber(
            values.IacRuhsatBasvuruTuruId
          ),
          sicilKodu: safelyParseNumber(values.sicilKodu),
          mahalleKodu: safelyParseNumber(values.mahalleKodu),
          caddeSokakKodu: safelyParseNumber(values.caddeSokakKodu),
          kapiNo: safelyParseNumber(values.kapiNo),
          daireNo:
            values.daireNo != "" ? safelyParseNumber(values.daireNo) : null,
          ada: values.ada != "" ? safelyParseNumber(values.ada) : null,
          parsel: values.parsel != "" ? safelyParseNumber(values.parsel) : null,
          vergiDairesiNo: safelyParseNumber(values.vergiDairesiNo),
          ticaretSicilNo: safelyParseNumber(values.ticaretSicilNo),
          isyeriSinifiKodu:
            values.isyeriSinifiKodu != null
              ? safelyParseNumber(values.isyeriSinifiKodu)
              : null,
          binaKullanimTuruKodu:
            values.binaKullanimTuruKodu != null
              ? safelyParseNumber(values.binaKullanimTuruKodu)
              : null,
          isyeriKonumuKodu:
            values.isyeriKonumuKodu != null
              ? safelyParseNumber(values.isyeriKonumuKodu)
              : null,
          mulkiyetDurumuKodu: safelyParseNumber(values.mulkiyetDurumuKodu),
          acikAlanM2:
            values.acikAlanM2 != ""
              ? safelyParseNumber(values.acikAlanM2)
              : null,
          kapaliAlanM2:
            values.kapaliAlanM2 != ""
              ? safelyParseNumber(values.kapaliAlanM2)
              : null,
          egitimUzaklik:
            values.egitimUzaklik != ""
              ? safelyParseNumber(values.egitimUzaklik)
              : null,
          dershaneUzaklik:
            values.dershaneUzaklik != ""
              ? safelyParseNumber(values.dershaneUzaklik)
              : null,
          ogrenciYurduUzaklik:
            values.ogrenciYurduUzaklik != ""
              ? safelyParseNumber(values.ogrenciYurduUzaklik)
              : null,
          ibadethaneUzaklik:
            values.ibadethaneUzaklik != ""
              ? safelyParseNumber(values.ibadethaneUzaklik)
              : null,
          captchaToken: token,
        };

        IsyeriBasvuruSave.saveIsyeriBasvuruBasvuruSave(transformedValues)
          .then(async (res) => {
            console.log(res);
            if (res.data.sonuc === 0) {
              const basvuruNo = res.data.basvuruNo;

              // DYS API'yi çağır 
              try {
                // Sadece dosyası olanları al
                const filesToSend = documents.filter((doc: any) => !!doc.file);

                if (filesToSend.length > 0) {
                  const formData = new FormData();

                  filesToSend.forEach((doc: any) => {
                    formData.append("files", doc.file, doc.file.name);
                    formData.append("rfObBasvuruTanimBelge", String(doc.id));
                  });

                  formData.append("basvuruTuru", String(values.basvuruTuruId || 0));
                  formData.append("basvuruId", String(basvuruNo));
                  formData.append("folderName", "AKOS");
                  formData.append("kurumId", "1");
                  formData.append("versionable", "1");

                  const response = await DysAPI.upload(formData);
                  toast.warning(response.message);
                } else {
                  // Burada return yok — sadece DYS çağrısını atlıyoruz.
                  
                }
              } catch (error: any) {
                toast.error("DYS upload hazırlama hatası:", error);
              }

              setPopupAciklama("İşleminiz başarıyla gerçekleştirildi. Başvuru Numaranız: " + basvuruNo);
              resetForm();
              setKayitBasarili(true);
              setDocuments((prevDocs: any[]) =>
                prevDocs.map((doc) => ({
                  ...doc,
                  file: null,
                  fileName: "",
                }))
              );
            } else {
              setPopupAciklama(res.data.sonucAciklama);
            }
          })
          .catch((err) => {
            setPopupAciklama(
              "İşleminizi gerçekleştirirken bir hata oluştu. Lütfen tekrar deneyiniz (API error)."
            );
          })
          .finally(() => {
            setIsPopupVisible(true);
            recaptchaRef.current?.reset();
            setLoadingSubmit(false);
          });
      }}
    >
      {(formikProps) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useEffect(() => {
          if (formikProps.values.mahalleKodu) {
            CaddeSokakAPI.getCaddeSokakListe(
              undefined,
              formikProps.values.mahalleKodu
            )
              .then((res) => setCaddeSokakData(res.data))
              .catch((err) => console.log(err));
          }
        }, [formikProps.values.mahalleKodu]);
        /*  // eslint-disable-next-line react-hooks/rules-of-hooks
             useEffect(() => {
               if (formikProps.values.mahalleKodu && formikProps.values.caddeSokakKodu) {
                 NumaratajKapiListeAPI.geNumaratajKapiListeListe(formikProps.values.mahalleKodu,formikProps.values.caddeSokakKodu)
                   .then(res => setNumaratajKapiListeDatas(res.data))
                   .catch(err => console.log(err))
               }
             }, [formikProps.values.mahalleKodu, formikProps.values.caddeSokakKodu]); */
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const showToastIfErrorsExist = () => {
          if (Object.keys(formikProps.errors).length > 0) {
            focusFirstErrorField();
            toast.error("Lütfen zorunlu alanları doldurun!");
          }
        };
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const formRefs = useRef<any>({});
        const focusFirstErrorField = () => {
          const errorKeys = Object.keys(formikProps.errors);
          if (errorKeys.length > 0) {
            const firstErrorKey = errorKeys[0];
            console.log(errorKeys[0]);
            const element = document.querySelector(`[name="${firstErrorKey}"]`);
            if (element) {
              (element as HTMLElement).focus();
            }
          }
        };
        return (
          <Form>
            <div className="row">
              <div className="col-12 mb-3">
                <div className="d-flex justify-content-end align-self-stretch">
                  <Button
                    type="button"
                    onClick={() => {
                      formikProps.resetForm({ values: formikProps.initialValues });
                      setDocuments((prevDocs: any[]) =>
                        prevDocs.map((doc) => ({
                          ...doc,
                          file: null,
                          fileName: "",
                        }))
                      );
                    }}
                    color="secondary"
                  >
                    Temizle
                  </Button>
                </div>
              </div>
              {/* First Column */}
              <div className="col-lg-4 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3">
                <div className="card w-100">
                  <div className="card-body w-100">
                    <div className="row">
                      <div className="col-12 mb-3">
                        <TextField
                          fullWidth
                          select
                          label="Başvuru Türü"
                          size="small"
                          value={formikProps.values.IacRuhsatBasvuruTuruId}
                          onChange={formikProps.handleChange}
                          name="IacRuhsatBasvuruTuruId"
                          error={
                            formikProps.touched.IacRuhsatBasvuruTuruId &&
                            Boolean(formikProps.errors.IacRuhsatBasvuruTuruId)
                          }
                        >
                          <MenuItem value="">
                            <em>Seçiniz...</em>
                          </MenuItem>
                          {basvuruTuruData.map((option: any) => (
                            <MenuItem
                              key={option.basvuruTuruId}
                              value={option.basvuruTuruId}
                            >
                              {option.basvuruTuruAdi}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          select
                          label="Mahalle *"
                          size="small"
                          value={formikProps.values.mahalleKodu}
                          onChange={formikProps.handleChange}
                          name="mahalleKodu"
                          error={
                            formikProps.touched.mahalleKodu &&
                            Boolean(formikProps.errors.mahalleKodu)
                          }
                        >
                          <MenuItem value="">
                            <em>Seçiniz...</em>
                          </MenuItem>
                          {mahalleListe.map((option) => (
                            <MenuItem
                              key={option.mahalleKodu}
                              value={option.mahalleKodu}
                            >
                              {option.mahalleAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          select
                          label="Cadde/Sokak *"
                          size="small"
                          value={formikProps.values.caddeSokakKodu}
                          onChange={formikProps.handleChange}
                          name="caddeSokakKodu"
                          error={
                            formikProps.touched.caddeSokakKodu &&
                            Boolean(formikProps.errors.caddeSokakKodu)
                          }
                        >
                          <MenuItem value="">
                            <em>Seçiniz...</em>
                          </MenuItem>
                          {caddeSokakData.map((option: any) => (
                            <MenuItem
                              key={option.caddeSokakKodu}
                              value={option.caddeSokakKodu}
                            >
                              {option.caddeSokakAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          label="Kapı No *"
                          size="small"
                          value={formikProps.values.kapiNo}
                          onChange={formikProps.handleChange}
                          name="kapiNo"
                          error={
                            formikProps.touched.kapiNo &&
                            Boolean(formikProps.errors.kapiNo)
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Alt Kapı No"
                          size="small"
                          value={formikProps.values.altKapiNo}
                          onChange={formikProps.handleChange}
                          name="altKapiNo"
                          error={
                            formikProps.touched.altKapiNo &&
                            Boolean(formikProps.errors.altKapiNo)
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Daire No"
                          size="small"
                          value={formikProps.values.daireNo}
                          onChange={formikProps.handleChange}
                          name="daireNo"
                          error={
                            formikProps.touched.daireNo &&
                            Boolean(formikProps.errors.daireNo)
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Alt Daire No"
                          size="small"
                          value={formikProps.values.altDaireNo}
                          onChange={formikProps.handleChange}
                          name="altDaireNo"
                          error={
                            formikProps.touched.altDaireNo &&
                            Boolean(formikProps.errors.altDaireNo)
                          }
                        />
                      </div>
                      <div className="col-md-12 mb-3">
                        <TextField
                          fullWidth
                          label="Site/Apartman Adı"
                          size="small"
                          value={formikProps.values.siteApartmanAdi}
                          onChange={formikProps.handleChange}
                          name="siteApartmanAdi"
                          error={
                            formikProps.touched.siteApartmanAdi &&
                            Boolean(formikProps.errors.siteApartmanAdi)
                          }
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <TextField
                          fullWidth
                          label="Pafta"
                          size="small"
                          value={formikProps.values.pafta}
                          onChange={formikProps.handleChange}
                          name="pafta"
                          error={
                            formikProps.touched.pafta &&
                            Boolean(formikProps.errors.pafta)
                          }
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <TextField
                          fullWidth
                          label="Ada"
                          size="small"
                          value={formikProps.values.ada}
                          onChange={formikProps.handleChange}
                          name="ada"
                          error={
                            formikProps.touched.ada &&
                            Boolean(formikProps.errors.ada)
                          }
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <TextField
                          fullWidth
                          label="Parsel"
                          size="small"
                          value={formikProps.values.parsel}
                          onChange={formikProps.handleChange}
                          name="parsel"
                          error={
                            formikProps.touched.parsel &&
                            Boolean(formikProps.errors.parsel)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Second Column */}
              <div className="col-lg-4 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3">
                <div className="card w-100">
                  <div className="card-body w-100">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          label="Vergi Dairesi *"
                          size="small"
                          value={formikProps.values.vergiDairesiAdi}
                          onChange={formikProps.handleChange}
                          name="vergiDairesiAdi"
                          error={
                            formikProps.touched.vergiDairesiAdi &&
                            Boolean(formikProps.errors.vergiDairesiAdi)
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          label="Vergi Numarası *"
                          size="small"
                          value={formikProps.values.vergiDairesiNo}
                          onChange={formikProps.handleChange}
                          name="vergiDairesiNo"
                          error={
                            formikProps.touched.vergiDairesiNo &&
                            Boolean(formikProps.errors.vergiDairesiNo)
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          label="Ticaret Sicil No *"
                          size="small"
                          value={formikProps.values.ticaretSicilNo}
                          onChange={formikProps.handleChange}
                          name="ticaretSicilNo"
                          error={
                            formikProps.touched.ticaretSicilNo &&
                            Boolean(formikProps.errors.ticaretSicilNo)
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          label="Ustalık Belge No *"
                          size="small"
                          value={formikProps.values.ustalikBelgeNo}
                          onChange={formikProps.handleChange}
                          name="ustalikBelgeNo"
                          error={
                            formikProps.touched.ustalikBelgeNo &&
                            Boolean(formikProps.errors.ustalikBelgeNo)
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          select
                          label="İşyeri Sınıfı"
                          size="small"
                          value={formikProps.values.isyeriSinifiKodu}
                          onChange={formikProps.handleChange}
                          name="isyeriSinifiKodu"
                          error={
                            formikProps.touched.isyeriSinifiKodu &&
                            Boolean(formikProps.errors.isyeriSinifiKodu)
                          }
                        >
                          <MenuItem value="">
                            <em>Seçiniz...</em>
                          </MenuItem>
                          {isyeriSinifiListe.map((option: any) => (
                            <MenuItem
                              key={option.isYeriSinifiKodu}
                              value={option.isYeriSinifiKodu}
                            >
                              {option.isYeriSinifiAdi}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          select
                          label="Faaliyeti"
                          size="small"
                          value={formikProps.values.binaKullanimTuruKodu}
                          onChange={formikProps.handleChange}
                          name="binaKullanimTuruKodu"
                          error={
                            formikProps.touched.binaKullanimTuruKodu &&
                            Boolean(formikProps.errors.binaKullanimTuruKodu)
                          }
                        >
                          <MenuItem value="">
                            <em>Seçiniz...</em>
                          </MenuItem>
                          {faaliyetListe.map((option: any) => (
                            <MenuItem
                              key={option.faaliyetKodu}
                              value={option.faaliyetKodu}
                            >
                              {option.faaliyetAdi}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                      <div className="col-md-6 mb-3">
                        <CustomTextField
                          fullWidth
                          select
                          label="Mülkiyet Durumu *"
                          size="small"
                          value={formikProps.values.mulkiyetDurumuKodu}
                          onChange={formikProps.handleChange}
                          name="mulkiyetDurumuKodu"
                          error={
                            formikProps.touched.mulkiyetDurumuKodu &&
                            Boolean(formikProps.errors.mulkiyetDurumuKodu)
                          }
                        >
                          <MenuItem value="">
                            <em>Seçiniz...</em>
                          </MenuItem>
                          {mulkiyetDurumuListe.map((option: any) => (
                            <MenuItem
                              key={option.mulkiyetDurumuKodu}
                              value={option.mulkiyetDurumuKodu}
                            >
                              {option.mulkiyetDurumuAdi}
                            </MenuItem>
                          ))}
                        </CustomTextField>
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          select
                          label="İşyeri Konumu"
                          size="small"
                          value={formikProps.values.isyeriKonumuKodu}
                          onChange={formikProps.handleChange}
                          name="isyeriKonumuKodu"
                          error={
                            formikProps.touched.isyeriKonumuKodu &&
                            Boolean(formikProps.errors.isyeriKonumuKodu)
                          }
                        >
                          <MenuItem value="">
                            <em>Seçiniz...</em>
                          </MenuItem>
                          {isyeriKonumuListe.map((option: any) => (
                            <MenuItem
                              key={option.isyeriKonumukodu}
                              value={option.isyeriKonumukodu}
                            >
                              {option.isyeriKonumuAdi}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>

                      <div className="col-md-6 mb-3">
                        <TimePicker
                          label="Yaz Açılış Saat"
                          value={formikProps.values.yazAcilisSaat ? dayjs(formikProps.values.yazAcilisSaat, "HH:mm") : null}
                          onChange={(value) => {
                            const formatted = value ? dayjs(value).format("HH:mm") : null;
                            formikProps.setFieldValue("yazAcilisSaat", formatted);
                          }}
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              error: formikProps.touched.yazAcilisSaat && Boolean(formikProps.errors.yazAcilisSaat),
                            },
                          }}
                        />

                      </div>
                      <div className="col-md-6 mb-3">
                        <TimePicker
                          label="Yaz Kapanış Saat"
                          value={formikProps.values.yazKapanisSaat ? dayjs(formikProps.values.yazKapanisSaat, "HH:mm") : null}
                          onChange={(value) => {
                            const formatted = value ? dayjs(value).format("HH:mm") : null;
                            formikProps.setFieldValue("yazKapanisSaat", formatted);
                          }}
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              error: formikProps.touched.yazKapanisSaat && Boolean(formikProps.errors.yazKapanisSaat),
                            },
                          }}
                        />

                      </div>
                      <div className="col-md-6 mb-3">
                        <TimePicker
                          label="Kış Açılış Saat"
                          value={formikProps.values.kisAcilisSaat ? dayjs(formikProps.values.kisAcilisSaat, "HH:mm") : null}
                          onChange={(value) => {
                            const formatted = value ? dayjs(value).format("HH:mm") : null;
                            formikProps.setFieldValue("kisAcilisSaat", formatted);
                          }}
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              error: formikProps.touched.kisAcilisSaat && Boolean(formikProps.errors.kisAcilisSaat),
                            },
                          }}
                        />

                      </div>
                      <div className="col-md-6 mb-3">
                        <TimePicker
                          label="Kış Kapanış Saat"
                          value={formikProps.values.kisKapanisSaat ? dayjs(formikProps.values.kisKapanisSaat, "HH:mm") : null}
                          onChange={(value) => {
                            const formatted = value ? dayjs(value).format("HH:mm") : null;
                            formikProps.setFieldValue("kisKapanisSaat", formatted);
                          }}
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              error: formikProps.touched.kisKapanisSaat && Boolean(formikProps.errors.kisKapanisSaat),
                            },
                          }}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Third Column */}
              <div className="col-lg-4 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3">
                <div className="card w-100">
                  <div className="card-body w-100">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Açık Alan M2"
                          size="small"
                          value={formikProps.values.acikAlanM2}
                          onChange={formikProps.handleChange}
                          name="acikAlanM2"
                          error={
                            formikProps.touched.acikAlanM2 &&
                            Boolean(formikProps.errors.acikAlanM2)
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Kapalı Alan M2"
                          size="small"
                          value={formikProps.values.kapaliAlanM2}
                          onChange={formikProps.handleChange}
                          name="kapaliAlanM2"
                          error={
                            formikProps.touched.kapaliAlanM2 &&
                            Boolean(formikProps.errors.kapaliAlanM2)
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Eğitim Uzaklık"
                          size="small"
                          value={formikProps.values.egitimUzaklik}
                          onChange={formikProps.handleChange}
                          name="egitimUzaklik"
                          error={
                            formikProps.touched.egitimUzaklik &&
                            Boolean(formikProps.errors.egitimUzaklik)
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Dershane Uzaklık"
                          size="small"
                          value={formikProps.values.dershaneUzaklik}
                          onChange={formikProps.handleChange}
                          name="dershaneUzaklik"
                          error={
                            formikProps.touched.dershaneUzaklik &&
                            Boolean(formikProps.errors.dershaneUzaklik)
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="Öğrenci Yurdu Uzaklık"
                          size="small"
                          value={formikProps.values.ogrenciYurduUzaklik}
                          onChange={formikProps.handleChange}
                          name="ogrenciYurduUzaklik"
                          error={
                            formikProps.touched.ogrenciYurduUzaklik &&
                            Boolean(formikProps.errors.ogrenciYurduUzaklik)
                          }
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <TextField
                          fullWidth
                          label="İbadethane Uzaklık"
                          size="small"
                          value={formikProps.values.ibadethaneUzaklik}
                          onChange={formikProps.handleChange}
                          name="ibadethaneUzaklik"
                          error={
                            formikProps.touched.ibadethaneUzaklik &&
                            Boolean(formikProps.errors.ibadethaneUzaklik)
                          }
                        />
                      </div>
                      <div className="col-12">
                        <TextField
                          fullWidth
                          label="Açıklama"
                          size="small"
                          value={formikProps.values.aciklama}
                          onChange={formikProps.handleChange}
                          name="aciklama"
                          error={
                            formikProps.touched.aciklama &&
                            Boolean(formikProps.errors.aciklama)
                          }
                          multiline
                          rows={6.5}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div ref={documentTableRef}>
                {!docsLoaded ? (
                  <div className="d-flex justify-content-center my-2"><CircularProgress size={24} /></div>
                ) : (
                  <DocumentTable rows={documents} onUpdateDocuments={handleUpdateDocuments} />
                )}
              </div>
              <div className="col-12 mt-3">
                <div className="d-flex justify-content-end align-self-stretch">
                  <Recaptcha
                    ref={recaptchaRef}
                    changeHandleRecaptcha={setRecaptchaPassed}
                  />
                  <Button
                    onClick={() => showToastIfErrorsExist()}
                    type="submit"
                  >
                    Gönder
                  </Button>

                  {loadingSubmit && (
                    <div
                      style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(255,255,255,0.6)",
                        zIndex: 1300,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <CircularProgress />
                    </div>
                  )}
                </div>
              </div>
              {isPopupVisible ? (
                <BilgilendirmePopup
                  basvuruTuruId={formikProps.values.basvuruTuruId}
                  isSorunBildirPopup={!kayitBasarili}
                  closePopup={closePopupSonuc}
                  open={isPopupVisible}
                  editDescription={popupAciklama}
                />
              ) : null}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
export default IsYeriRuhsatBasvuru;
